module.exports = __webpack_public_path__ + "img/bgc3.fb0a6f27.png";